import { useEffect, useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { Card, CardContent } from '../components/ui/card';
import { clearanceAPI } from '../lib/clearanceAPI';

export default function AuthorityComplete() {
  const [params] = useSearchParams();
  const [status, setStatus] = useState('checking');
  useEffect(() => {
    const id = params.get('case');
    let n = 0;
    const tick = () => clearanceAPI.myRefresh(id).then((r) => { if (r.status === 'signed' || n++ > 8) setStatus(r.status); else setTimeout(tick, 3000); }).catch(() => setStatus('error'));
    if (id) tick();
  }, [params]);
  return (
    <div className="p-6 max-w-xl mx-auto"><Card><CardContent className="p-6 space-y-3" data-testid="authority-complete">
      <h1 className="text-2xl font-semibold">Thank you</h1>
      <p className="text-sm" data-testid="authority-complete-status">{status === 'signed' ? 'Your signed authority has been received. A copy is in your Documents.'
        : status === 'checking' ? 'Confirming your signature…' : 'We are still confirming your signature – this page will update shortly, or check back later.'}</p>
      <Link className="underline text-sm" to="/my-letters">Back to my letters</Link>
    </CardContent></Card></div>
  );
}
